import { Component, OnInit, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { TranslatePipe } from '@ngx-translate/core';
import { LaddaModule } from 'angular2-ladda';
import { WorkflowDataStoreService } from '../services/workflowDataStore.service';
import { WorkflowDataStore } from './workflow-data-store';

_('workflow_data_store.singular');
_('workflow_data_store.name');
_('workflow_data_store.identifier');
_('workflow_data_store.description');

@Component({
  selector: 'app-workflow-data-store-form',
  templateUrl: './workflow-data-store-form.component.html',
  imports: [TranslatePipe, ReactiveFormsModule, ErrorComponent, LaddaModule],
})
export class WorkflowDataStoreFormComponent implements OnInit {
  modalRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(
    DynamicDialogConfig<{ value: WorkflowDataStore }>,
  );
  private formBuilder = inject(FormBuilder);
  private service = inject(WorkflowDataStoreService);

  value: WorkflowDataStore = {} as WorkflowDataStore;

  loading = false;

  error?: HttpErrorResponse;

  form = this.formBuilder.group({
    name: ['', Validators.required],
    identifier: ['', Validators.required],
    description: [''],
  });

  ngOnInit(): void {
    this.value = this.dialogConfig.data!.value;
    this.form.patchValue({
      name: this.value.name ?? '',
      identifier: this.value.identifier ?? '',
      description: this.value.description ?? '',
    });
  }

  save(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this.error = undefined;
    this.loading = true;
    this.form.disable();
    const payload = {
      ...this.value,
      ...this.form.getRawValue(),
    } as WorkflowDataStore;

    this.service.createOrUpdate(payload).subscribe({
      next: (value) => {
        this.value = value;
        this.loading = false;
        this.modalRef.close();
      },
      error: (response: HttpErrorResponse) => {
        this.error = response;
        this.loading = false;
        this.form.enable();
      },
    });
  }
}
